import React from 'react';
import { ButtonStandardType } from '../../button/ButtonStandard/ButtonStandard';
import {
  DropdownButton,
  DropdownButtonProps
} from '../../button/DropdownButton/DropdownButton';
import { useScreenSm } from '../../hooks/mediaQueries/useScreenSm';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { Icon, IconType } from '../Icon/Icon';

export type CreateEntityButtonProps<TDropdownItem> = PropsWithoutChildren<
  Omit<
    DropdownButtonProps<TDropdownItem>,
    | 'items'
    | 'getDisplayTextOfItem'
    | 'getKeyOfItem'
    | 'onItemSelected'
    | 'type'
  >
> & {
  text: string;
  dropdownItems: Array<TDropdownItem>;
  getDropdownItemDisplayText: (item: TDropdownItem) => string;
  getDropdownItemKey: (item: TDropdownItem) => string;
  onCreateEntity: (item: TDropdownItem | null) => void;
};

export const CreateEntityButton = React.memo(
  <TDropdownItem,>(props: CreateEntityButtonProps<TDropdownItem>) => {
    const {
      text,
      dropdownItems,
      getDropdownItemDisplayText,
      getDropdownItemKey,
      onCreateEntity,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    const screenSm = useScreenSm();

    return (
      <DropdownButton<TDropdownItem>
        {...remainingProps}
        items={dropdownItems}
        getDisplayTextOfItem={getDropdownItemDisplayText}
        getKeyOfItem={getDropdownItemKey}
        onItemSelected={onCreateEntity}
        type={ButtonStandardType.Primary}
      >
        {screenSm ? text : null}
        <Icon
          name="plus-circle"
          type={IconType.Light}
          hasTextOnLeftSide={screenSm}
          hasTextOnRightSide={dropdownItems.length > 1}
        ></Icon>
      </DropdownButton>
    );
  }
) as <TDropdownItem>(
  props: CreateEntityButtonProps<TDropdownItem>
) => JSX.Element;
